import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import TransferSchedule from '~/containers/transferSchedule/transferSchedule';

export class TransferSchedulePage extends Component {
  state = {
    transferSchedule: null
  };

  onReceiveTransferSchedule = ({ transferSchedule }) => {
    this.setState({
      transferSchedule
    });
  };

  render() {
    const transferScheduleId = this.props.match.params.transferScheduleId;
    const { transferSchedule } = this.state;

    const editButton = (
      <Link to={`/settings/transfers/${transferScheduleId}/edit`}>
        <Button color="primary">Edit</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar
          back="/settings/transfers"
          backText="Transfer Schedules"
          title={transferSchedule ? transferSchedule.name : '...'}
          button={editButton}
        />
        <TransferSchedule onCompleted={this.onReceiveTransferSchedule} id={transferScheduleId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(TransferSchedulePage));



// WEBPACK FOOTER //
// ./src/pages/transferSchedule/transferSchedule.jsx